module.exports = __webpack_public_path__ + "static/img/service_card_bg_zh.32cd87e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_card_bg_zh.png
// module id = iXH5
// module chunks = 34